import { useDispatch } from "react-redux";
import { useMutation, useQueryClient } from "@tanstack/react-query"

import { createEvento } from "../services/cita.service";

import { successNotification, dangerNotification } from '../../../../redux/slices/ui';

export const useEventoNuevo = () => {

    const dispatch = useDispatch();

    const queryClient = useQueryClient();

    const createEventoMutation = useMutation({
        mutationFn: createEvento,
        onSuccess: ({ inactivoFlag, horarioFlag, empalmadaFlag, cita }, variables, context) => {
            if(inactivoFlag){
                variables.onInactivo();
            }else if(horarioFlag){
                variables.onHorario();
            }else if(empalmadaFlag){
                variables.onEmpalmada();
            }else{
                queryClient.invalidateQueries({ queryKey: ['agenda'], exact: false });
                variables.onComplete();
                variables.onSuccess();
                dispatch(successNotification('Evento creado'));
            }
        },
        onError: (error, variables, context) => {
            variables.onComplete();
            dispatch(dangerNotification(error.message));
            // dispatch(dangerNotification(error.msg.message));
        }
    });

    return {
        createEventoMutation,
    }
}